<div class="d-flex flex-column justify-content-center1 align-items-center">
  <a class="m-tooltip-title d-flex align-items-center" (keypress)="simulateClick($event)" role="button" tabindex="0" placement="bottom" [ngbPopover]="popContent" #p="ngbPopover">{{qTitle}}</a>
</div>

<!-- <button class="m-start-tooltip"
  placement="bottom"
  triggers="click:blur"
  ngbTooltip="{{'START.TOOLTIP_TEXT' | translate}}">
  <span class="">{{'START.LINK_TOOLTIP' | translate}}</span>
</button> -->

<ng-template #popContent>
  <button type="button" class="m-close-btn" aria-label="Close" (click)="closePopover()">
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="">
      {{text}}
  </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/inner-tooltip/inner-tooltip.component.html